import script from "./AddTagComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AddTagComponent.vue?vue&type=script&setup=true&lang=js"

import "./AddTagComponent.vue?vue&type=style&index=0&id=a3bd64a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3bd64a2"]])

export default __exports__